export default __webpack_public_path__ + "static/chunks/ui-assets/pattern-open-black/3965aa70da9a0725326d8075839278c8.webp";